export default __webpack_public_path__ + "static/media/11.c10bebce.svg";